import { render, staticRenderFns } from "./channel-activity.vue?vue&type=template&id=cc4c11a2&scoped=true"
import script from "./channel-activity.vue?vue&type=script&lang=js"
export * from "./channel-activity.vue?vue&type=script&lang=js"
import style0 from "./channel-activity.vue?vue&type=style&index=0&id=cc4c11a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4c11a2",
  null
  
)

export default component.exports